import { api } from './client';
import type { UUID } from './types';

/** #14 P3 — admin management of group defaults + per-user overrides.
 *  Backed by /admin/permissions/* (gated user.manage_permissions). */

export interface PermissionCatalogueItem {
  key: string;
  description: string | null;
}

export interface GroupPermissions {
  id: UUID;
  name: string;
  is_system: boolean;
  permission_keys: string[];
}

export interface OverrideItem {
  permission_key: string;
  allow: boolean;
}

export interface UserPermissionsView {
  user_id: UUID;
  email: string;
  display_name: string;
  role: string;
  group_id: UUID | null;
  group_name: string | null;
  inherited: string[];   // group-default baseline
  overrides: OverrideItem[];
  effective: string[];   // resolved (what the user can actually do)
}

export const permissionsAdminApi = {
  catalogue: () => api.get<PermissionCatalogueItem[]>('/admin/permissions/catalogue'),
  groups:    () => api.get<GroupPermissions[]>('/admin/permissions/groups'),
  userPermissions: (userId: UUID) =>
    api.get<UserPermissionsView>(`/admin/permissions/users/${userId}`),
  grantGroup: (groupId: UUID, key: string) =>
    api.put<GroupPermissions>(`/admin/permissions/groups/${groupId}/permissions/${key}`),
  revokeGroup: (groupId: UUID, key: string) =>
    api.delete<GroupPermissions>(`/admin/permissions/groups/${groupId}/permissions/${key}`),
  setOverride: (userId: UUID, key: string, allow: boolean) =>
    api.put<UserPermissionsView>(`/admin/permissions/users/${userId}/overrides/${key}`, { allow }),
  clearOverride: (userId: UUID, key: string) =>
    api.delete<UserPermissionsView>(`/admin/permissions/users/${userId}/overrides/${key}`),
};
